export default function CtaFinal() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7ea3492186b2bcf26897811e251bd280.jpg"
          alt="Massagistas disponíveis em Curitiba"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/85 via-stone-900/70 to-stone-900/50"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-rose-300 text-sm font-semibold tracking-widest uppercase mb-4 block">Acesso Imediato</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-5 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Veja agora as massagistas disponíveis em Curitiba
          </h2>
          <p className="text-stone-300 text-base md:text-lg leading-relaxed mb-10">
            Acesse o catálogo completo com perfis verificados, fotos reais, especialidades e contato direto das melhores <strong className="text-white">massagistas em Curitiba</strong> com atendimento imediato.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://classivip.com/massagistas"
              target="_blank"
              rel="nofollow noopener"
              className="bg-rose-400 hover:bg-rose-500 text-white font-bold px-8 py-4 rounded-full text-base transition-all duration-300 hover:scale-105 text-center whitespace-nowrap shadow-lg"
            >
              <i className="ri-arrow-right-circle-line mr-2 text-lg"></i>
              Ver agora – Acesso gratuito
            </a>
            <a
              href="#bairros"
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 border border-white/30 text-white font-medium px-8 py-4 rounded-full text-base transition-all text-center whitespace-nowrap"
            >
              <i className="ri-map-pin-line mr-2"></i>
              Buscar por bairro
            </a>
          </div>

          <div className="mt-10 flex flex-wrap gap-6">
            <div className="flex items-center gap-2 text-stone-300 text-sm">
              <i className="ri-shield-check-line text-rose-300 text-base"></i>
              Atendimento verificado
            </div>
            <div className="flex items-center gap-2 text-stone-300 text-sm">
              <i className="ri-lock-line text-rose-300 text-base"></i>
              100% discreto
            </div>
            <div className="flex items-center gap-2 text-stone-300 text-sm">
              <i className="ri-time-line text-rose-300 text-base"></i>
              Disponibilidade 24h
            </div>
            <div className="flex items-center gap-2 text-stone-300 text-sm">
              <i className="ri-map-pin-2-line text-rose-300 text-base"></i>
              Toda Curitiba
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
